// extracted by mini-css-extract-plugin
var _1 = "P_I_xQ7J8kwIeEpiEthD";
export { _1 as "notes" }
